import { reaction } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { getOrCreateBrowserUrlModel } from './BrowserUrlModel';

export const DeepLinkUrlSync = observer(function DeepLinkUrlSync() {
	const navigate = useNavigate();
	const { search } = useLocation();
	const browserUrlModel = getOrCreateBrowserUrlModel();

	useEffect(
		function ingestUrlIntoModel(): void {
			browserUrlModel.setSearch(search);
		},
		[search, browserUrlModel],
	);

	useEffect(
		function projectModelIntoUrl() {
			return reaction(
				// Why not just use useEffect?
				() => browserUrlModel.search,
				function navigateOnModelChange(nextSearch) {
					if (nextSearch !== globalThis.location.search) {
						navigate({ search: nextSearch }, { replace: true });
					}
				},
			);
		},
		[navigate, browserUrlModel],
	);

	return null;
});
